import { Injectable } from '@angular/core'
import { Observable, Subject, filter, map } from 'rxjs'

export interface TvEvent {
  type: 'attendance' | 'workouts' | 'reconnected'
  data?: any
}

@Injectable({providedIn:'root'})
export class BroadcastService {
  private _events = new Subject<TvEvent>()

  on (type: TvEvent['type']): Observable<any> {
    return this._events.pipe(filter((e) => e.type === type), map((e) => e.data))
  }

  emit (event: TvEvent) {
    this._events.next(event)
  }
}
